import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class AcousticSignalBehaviour extends AbstractDataAttributeBehaviour {
    attrSelectors = {
        container: 'data-signal',
        context: 'data-signal-context',
        trigger: 'data-signal-trigger'
    };

    getContainerSelector()
    {
        return '[' + this.attrSelectors.container + ']';
    }

    initContainer(container) {

        const eventId = container.getAttribute(this.attrSelectors.container);
        const trigger = container.getAttribute(this.attrSelectors.trigger) || "click";
        const context = container.getAttribute(this.attrSelectors.context) || {};

        // Register if needed
        window.app.eventManager.createEvent(eventId, eventId);

        if (trigger === "load") {
            window.app.eventManager.triggerEvent(eventId, context);
        }

        container.addEventListener(trigger, () => {
            window.app.eventManager.triggerEvent(eventId, JSON.parse(context));
        })
    }
}